import { put, takeLeading } from 'redux-saga/effects';
import vatSettingApi from 'api/vatSettingApi';
import { apiErrorHandler, showSuccess } from 'utils';

import {
  GET_VAT_SETTING_LIST,
  CREATE_VAT_SETTING,
  UPDATE_VAT_SETTING,
} from './actionTypes';

import {
  actionGetVatSettingListSuccess,
  actionGetVatSettingListFailed,
  actionCreateVatSettingSuccess,
  actionCreateVatSettingFailed,
  actionUpdateVatSettingSuccess,
  actionUpdateVatSettingFailed,
} from './actions';

function* getVatSettingList({ payload }) {
  try {
    const response = yield vatSettingApi.getVatSettings(payload);
    const resData = response?.data || response;
    const result = resData?.payload || resData;
    yield put(actionGetVatSettingListSuccess(result));
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionGetVatSettingListFailed(error));
  }
}

function* createVatSetting({ payload }) {
  const { values, callback, onCallBackSave } = payload || {};
  const dataToSend = values || (payload.value ? payload : payload.data);

  try {
    const response = yield vatSettingApi.createVatSetting(dataToSend);
    yield put(actionCreateVatSettingSuccess(response?.payload || response));
    showSuccess('Thêm thuế GTGT thành công');

    const cb = callback || onCallBackSave || payload.onSuccess;
    if (cb && typeof cb === 'function') {
      cb(response?.payload || response);
    }
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionCreateVatSettingFailed(error));
  }
}

function* updateVatSetting({ payload }) {
  const { id, values, callback, onCallBackSave } = payload || {};
  const targetId = id || payload?._id || values?.id || values?._id;
  const dataToSend = values || (payload.value ? payload : payload.data);

  try {
    const response = yield vatSettingApi.updateVatSetting(targetId, dataToSend);
    yield put(actionUpdateVatSettingSuccess(response?.payload || response));
    showSuccess('Cập nhật thuế GTGT thành công');

    const cb = callback || onCallBackSave || payload.onSuccess;
    if (cb && typeof cb === 'function') {
      cb(response?.payload || response);
    }
  } catch (error) {
    apiErrorHandler(error);
    yield put(actionUpdateVatSettingFailed(error));
  }
}

export default function* vatSettingSaga() {
  yield takeLeading(GET_VAT_SETTING_LIST, getVatSettingList);
  yield takeLeading(CREATE_VAT_SETTING, createVatSetting);
  yield takeLeading(UPDATE_VAT_SETTING, updateVatSetting);
}
